import { CustomizationContext } from '@faceup/ui'
import { type ReactNode, useContext, useEffect } from 'react'
import { SurveyDataContext } from '../../Contexts/SurveySourceProvider'
import { FullScreenLoader } from '../FullScreenLoader'
import { AppWrapper } from '../InstitutionLayout/AppWrapper'
import { SurveyHeader } from './SurveyHeader'

type SurveyLayoutProps = {
  headerVariant?: 'simple' | 'simple-no-back-button'
  children?: ReactNode
}

export const SurveyLayout = ({ children, headerVariant }: SurveyLayoutProps) => {
  const { changeColors, changeIsBrandingHidden } = useContext(CustomizationContext)
  const survey = useContext(SurveyDataContext)

  useEffect(() => {
    if (!survey) {
      return
    }

    changeColors({
      primaryColor:
        survey.institution.config?.primaryColor ??
        survey.institution.partner?.config?.primaryColor ??
        undefined,
    })
    changeIsBrandingHidden(
      survey.institution.config?.isBrandingHidden ??
        survey.institution.partner?.config?.isBrandingHidden ??
        false
    )
  }, [survey, changeColors, changeIsBrandingHidden])

  if (!survey) {
    return <FullScreenLoader />
  }

  // Use institution config only when it explicitly set isBrandingHidden;
  // `!= null` catches both a null config and an undecided (null) isBrandingHidden.
  const config =
    survey.institution.config?.isBrandingHidden != null
      ? survey.institution.config
      : survey.institution.partner?.config

  return (
    <AppWrapper
      variant='simple'
      headerComponent={
        <SurveyHeader
          survey={survey}
          isHiddenBackButton={headerVariant === 'simple-no-back-button'}
        />
      }
      config={config ?? undefined}
    >
      {children}
    </AppWrapper>
  )
}
